import './ResultListTableComponent.scss'
import React, {useCallback} from 'react';
import {ITableColumn} from "../../../../shared/models/table.model";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import {CommonService} from "../../../../shared/services";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import TableWrapperV2Component
    from "../../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import {APIConfig} from "../../../../constants";
import commonService from "../../../../shared/services/common.service";
import TooltipComponent from "../../../../shared/components/tooltip/tooltipComponent";

interface ResultListTableComponentProps {
    filterData: any;
}

const ResultListTableComponent = (props: ResultListTableComponentProps) => {
    const {filterData} = props;

    const columns: ITableColumn[] = [
        {
            id: 'id',
            label: 'Session ID',
            isDefaultColumn: true,
            sortable: false,
            fixed: "left",
            width: "100",
            align: "center"
        },
        {
            id: 'testDetails.name', label: 'Test Name', isDefaultColumn: true, fixed: "left", width: "250",
            content: (item: any) => (
                <>
                    {
                        (item?.testDetails?.name)?.length > 23 ?
                            <TooltipComponent
                                tooltip={CommonService.capitalizeFirstLetterOfEachWord(item?.testDetails?.name)}
                                placement={"top"}
                                arrow={true}
                            >
                                <div className={"ellipses-for-table-data"}>
                                    {CommonService.capitalizeFirstLetterOfEachWord(item?.testDetails?.name)}
                                </div>
                            </TooltipComponent> :
                            <>
                                {CommonService.capitalizeFirstLetterOfEachWord(item?.testDetails?.name)}
                            </>
                    }
                </>
            )
        },
        {
            id: 'createdAt', label: 'Added On', align: 'center',
            isDefaultColumn: true,
            content: (item: any) => (
                <>
                    {
                        item.createdAt ?
                            <>
                                {commonService.formatDate(item?.createdAt)}
                                &nbsp;|&nbsp;
                                {commonService.formatTime(item?.createdAt)} <br/>
                            </> : <> - </>
                    }
                </>

            )
        },
        {
            id: 'addedBy', label: 'Added by', sortable: false, isDefaultColumn: true, align: 'center',
            content: (item: any) => (
                <>
                    {commonService.capitalizeFirstLetterOfEachWord(item?.createdByDetails?.firstName)}  {commonService.capitalizeFirstLetterOfEachWord(item?.createdByDetails?.lastName)}
                </>
            )
        },
        {
            id: 'numberOfSamples',
            label: 'Test Samples',
            sortable: false,
            isDefaultColumn: true,
            width: "150",
            align: "center"
        },
        {
            id: 'actions', label: '', sortable: false, isDefaultColumn: true,
            fixed: "right",
            align: 'center',
            width: "200",
            content: (item: any) => (
                <ButtonComponent
                    color={'primary'}
                    variant={'outlined'}
                    size={"small"}
                    startIcon={<ArrowDownwardIcon/>}
                    handleClick={() => {
                        downloadResultExcel(item.attachmentDetails)
                    }}
                >Download XLS</ButtonComponent>
            )
        },

    ];

    const downloadResultExcel = useCallback((attachmentDetails: any) => {
        CommonService.downloadFile(attachmentDetails.url, attachmentDetails.title || 'result.xlsx', 'xlsx')
    }, []);

    return (
        <>
            <div className="table-list-container">
                <TableWrapperV2Component
                    url={APIConfig.RESULT_LIST.URL}
                    method={APIConfig.RESULT_LIST.METHOD}
                    isPaginated={true}
                    columns={columns}
                    extraPayload={filterData}
                />
            </div>
        </>
    )
}
export default ResultListTableComponent;
